(function () {
  function sync() {
    const bar = document.querySelector('[class*="essential_annoucement_bar_wrapper"]');
    const nav = document.querySelector('.site-control.fixed');
    if (!bar) {
      document.body.style.paddingTop = '';
      if (nav) nav.style.top = '';
      document.documentElement.style.setProperty('--bar-nav-bottom', '');
      return;
    }
    const pad = parseFloat(getComputedStyle(document.body).paddingTop);
    const h = bar.offsetHeight;
    bar.style.marginTop = (-pad) + 'px';
    if (nav) {
      nav.style.top = h + 'px';
      // bottom edge of the displaced nav = banner height + nav height
      document.documentElement.style.setProperty('--bar-nav-bottom', (h + nav.offsetHeight) + 'px');
    }
  }
  sync();
  window.addEventListener('resize', sync);
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
})();
